'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBannerClassNames = exports.linkOrButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Returns either an `a` or `button` element (and appropriate props) depending
 * on the passed values for href and onClick.
 */
var linkOrButton = exports.linkOrButton = function linkOrButton(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      _ref$hasButton = _ref.hasButton,
      hasButton = _ref$hasButton === undefined ? false : _ref$hasButton,
      _ref$shouldOpenInNewW = _ref.shouldOpenInNewWindow,
      shouldOpenInNewWindow = _ref$shouldOpenInNewW === undefined ? false : _ref$shouldOpenInNewW;

  var element = void 0;
  var props = {};

  switch (true) {
    case !!href:
      element = 'a';
      props = {
        href: href,
        tabIndex: 0
      };

      if (shouldOpenInNewWindow) {
        props = _extends({}, props, {
          rel: 'noopener',
          target: '_blank'
        });
      }

      break;
    case !hasButton && !!onClick:
      element = 'button';
      props = {
        type: 'button',
        tabIndex: 0
      };

      break;
    default:
      element = 'div';
  }

  if (!hasButton) {
    props = _extends({}, props, {
      onClick: onClick
    });
  }

  return [element, props];
};

/**
 * Convenience method to assemble various banner classnames used by PromoBanner
 * and ServiceBanner.
 */
var getBannerClassNames = exports.getBannerClassNames = function getBannerClassNames(_ref2) {
  var _classnames;

  var styles = _ref2.styles,
      theme = _ref2.theme,
      isClickable = _ref2.isClickable,
      hasIcon = _ref2.hasIcon,
      isMobileRow = _ref2.isMobileRow,
      isPlaceholder = _ref2.isPlaceholder;
  return (0, _classnames3.default)(styles.banner, (_classnames = {}, _defineProperty(_classnames, styles[theme], !!theme), _defineProperty(_classnames, styles.clickable, isClickable), _defineProperty(_classnames, styles.withIcon, hasIcon), _defineProperty(_classnames, styles.row, isMobileRow), _defineProperty(_classnames, styles.placeholder, isPlaceholder), _classnames));
};